import {onFind} from "@elements/init-modules-in-scope";
import {removeClass,addClass,on,findAllIn, findIn} from '@elements/dom-utils';
import Popover from 'bootstrap/js/dist/popover';

const selectors = {
    base: '.js-return',
    items: '.js-return__item',
    quantity: '.js-return__quantity',
    reason: '.js-return__reason',
    confirm: '.js-return__confirm',
    quantityInput: '.js-return__quantity-input',
    reasonInput: '.js-return__reason-input'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let items = findAllIn(selectors.items, baseElement);
        let submitButton = findIn('.js-return__submit', baseElement);
        let submitText = findIn('.js-return__submit-text', baseElement);

        items.forEach((item, index) => {
            let quantity = findIn(selectors.quantity, item);
            let reason = findIn(selectors.reason, item);
            let confirm = findIn(selectors.confirm, item);
            let quantityInput = findIn(selectors.quantityInput, item);
            let reasonInput = findIn(selectors.reasonInput, item);
            let stateDefault = findIn('.js-return__state-default', item);
            let stateSuccess = findIn('.js-return__state-success', item);
            let stateWarning = findIn('.js-return__state-warning', item);

            //quantity on change
            on('change', function () {
                let selectedOption = quantityInput.options[quantityInput.selectedIndex];
                reasonInput.selectedIndex = 0;

                /* show and hide return-reason and states */
                if(selectedOption.value !== "0" && selectedOption.value !== ""){
                    removeClass('visually-hidden', reason);
                    addClass('visually-hidden', stateDefault);
                    removeClass('visually-hidden', stateWarning);
                    addClass('visually-hidden', stateSuccess);
                    if(confirm) {
                        confirm.removeAttribute('hidden');
                    }
                } else {
                    addClass('visually-hidden', reason);
                    removeClass('visually-hidden', stateDefault);
                    addClass('visually-hidden', stateWarning);
                    addClass('visually-hidden', stateSuccess);
                    if(confirm) {
                        confirm.setAttribute('hidden', true);
                    }
                }

                checkSubmitButton();

            }, quantity);

            //reason on change
            on('change', function () {
                let selectedOption = reasonInput.options[reasonInput.selectedIndex];

                /* change states */
                if(reasonInput.value !== ""){
                    addClass('visually-hidden', stateWarning);
                    addClass('visually-hidden', stateDefault);
                    removeClass('visually-hidden', stateSuccess);
                } else {
                    removeClass('visually-hidden', stateWarning);
                    addClass('visually-hidden', stateSuccess);
                    addClass('visually-hidden', stateDefault);
                }

                checkSubmitButton();

            }, reason);


            function checkSubmitButton(){
                /* check if any return item has success and enable submit button */
                let stateSuccesses = findAllIn('.js-return__state-success', baseElement);
                let submitButtonHidden = true;

                stateSuccesses.forEach((stateSuccess) => {
                    if(!stateSuccess.classList.contains('visually-hidden')){
                        submitButtonHidden = false;
                    }
                });

                if(submitButtonHidden){
                    submitButton.setAttribute('disabled', true);
                    submitText.removeAttribute('hidden');
                } else {
                    submitButton.removeAttribute('disabled');
                    submitText.setAttribute('hidden', true);
                }
            }



        })
    });
}
